<template>
    <div>
        <pre style="display: none">
      {{ environment }}
    </pre
        >
        <div v-if="name">
            <h4 class="tw:mt-5! tw:pl-10">Select the service you would like to manage.</h4>

            <ul class="tw:mb-0!">
                <li
                    v-for="s in serviceMemberships"
                    :key="s.id"
                    class="tw:mb-2! tw:overflow-hidden tw:bg-white tw:shadow tw:sm:rounded-md"
                >
                    <div class="tw:flex tw:items-center tw:px-4 tw:py-4 tw:sm:px-6">
                        <div
                            class="tw:flex tw:min-w-0 tw:flex-1 tw:items-center tw:justify-between"
                        >
                            <div class="tw:truncate">
                                <div class="tw:flex tw:text-sm">
                                    <router-link
                                        :to="{ name: 'carwash-home', params: { service_id: s.id } }"
                                        class="tw:no-underline tw:truncate tw:font-medium tw:text-indigo-600"
                                        >{{ s.name }}
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div
            v-else
            class="tw:flex tw:min-h-full tw:items-center tw:justify-center tw:py-12 tw:sm:px-6 tw:lg:px-8"
        >
            <div class="tw:flex tw:flex-col tw:justify-center tw:items-center">
                <img class="tw:mx-auto tw:h-32 tw:w-auto" :src="carheroImg" alt="Car Hero" />
                <h2
                    class="tw:mt-6! tw:text-center tw:text-3xl tw:font-bold tw:tracking-tight tw:text-gray-900"
                >
                    Sign in to your account
                </h2>
                <p class="tw:mt-2! tw:text-center tw:text-sm tw:text-gray-600">
                    If you don't have an account yet, contact our sales team <br />to have your
                    account created.
                </p>
                <div class="tw:mt-1!">
                    <button @click="doSignIn" class="sign-in-with-google-button">
                        <img :src="signinWithGoogleImage" alt="Sign in with Google" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { firebaseAuth } from '@/firebase/auth';
import { useUserStore } from '@/stores/user';
import { getServiceMemberships } from '@/api';
import carheroImg from '@/assets/car-hero-v2-logo.png';
import signinWithGoogleImage from '@/assets/sign-in-with-google-web_neutral_rd_si.svg';


export default {
  data() {
    return {
      carheroImg: carheroImg,
      signinWithGoogleImage: signinWithGoogleImage,
    }
  },
    mounted() {
      // Set document title for Sign In page
      document.title = 'Sign In | Car-Hero Console';
      
      if (this.serviceMemberships.length === 1) {
          this.$router.replace({ name: 'carwash-home', params: { service_id: this.serviceMemberships[0].id } });
      }
    },
    computed: {
    environment: function () {
      return import.meta.env.PROD ? 'production' : 'development';
    },
    name: function () {
      const userStore = useUserStore();

      return userStore.name;
    },
    serviceMemberships: function () {
      const userStore = useUserStore();

      return userStore.serviceMemberships;
    },
  },
  methods: {
    async fetchServiceMemberships() {
      const userStore = useUserStore();

      const fetchResponse = await getServiceMemberships(userStore.service_provider_id);
      if (fetchResponse.status !== 200) {
        return;
      }

      const response = await fetchResponse.json();
      const carwashOnly = response['services'].filter((s) => {
        const carwashServiceTypeKey = 'c';

        return s.service_type.key === carwashServiceTypeKey;
      });
      // since the console is only for carwash services right now, we are
      // filtering out other service types that are not a carwash. we would
      // need to remove/or update this to handle other service types in the future.
      userStore.setServiceMemberships(carwashOnly);

      if (carwashOnly.length === 1) {
        this.$router.replace({ name: 'carwash-home', params: { service_id: response.services[0].id } });
      }
    },
    doSignIn() {
      const provider = new GoogleAuthProvider();

      signInWithPopup(firebaseAuth, provider)
        .then(async (result) => {
          const currentUser = firebaseAuth.currentUser;

          const idToken = await currentUser.getIdToken(/* forceRefresh */ true)
          const userStore = useUserStore();

          await userStore.login(idToken);
          await this.fetchServiceMemberships();
        });
    }
  },
}
</script>

<style scoped>
.sign-in-with-google-button {
    border: 0;
    background: transparent;
    cursor: pointer;
    transition: transform 0.2s;
}

.sign-in-with-google-button:hover {
    transform: scale(1.05);
}

.sign-in-with-google-button:active {
    transform: scale(0.95);
}
</style>
